const federationFragmentManifest = "federation.manifest.json";
const fragmentDefaultEntryName = "defaultEntry";
const fragmentDefaultComponentName = "defaultComponent";
export {
  fragmentDefaultComponentName as a,
  federationFragmentManifest as b,
  fragmentDefaultEntryName as f
};
//# sourceMappingURL=consts.js.map
